import { Comment, History, Person, PersonAdd, PersonRemove } from '@mui/icons-material';
import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import React from 'react';

export interface CustomTimelineItem {
    type: 'user' | 'assign' | 'unassign' | 'comment' | 'history' | '',
    content: JSX.Element,
    left?: JSX.Element,
}

const timelineIcon = {
    'user': <Person />,
    'assign': <PersonAdd />,
    'unassign': <PersonRemove />,
    'comment': <Comment />,
    'history': <History />,
    '': <></>
}

export const CustomTimeline: React.FC<{ items: CustomTimelineItem[] }> = ({ items }) => {
    return (
        <Timeline position="right" sx={{
            [`& .${timelineItemClasses.root}:before`]: {
                flex: 0,
                padding: 0,
            },
        }}>

            {items.map((item, index) => {
                return <TimelineItem key={index}>
                    {item.left && <TimelineOppositeContent sx={{ m: 'auto 0' }} align="right">
                        {item.left}
                    </TimelineOppositeContent>}

                    <TimelineSeparator>
                        <TimelineConnector />
                        <TimelineDot>
                            {timelineIcon[item.type]}
                        </TimelineDot>
                        <TimelineConnector />
                    </TimelineSeparator>

                    <TimelineContent sx={{ py: '12px', px: 2 }}>
                        {item.content}
                    </TimelineContent>
                </TimelineItem>
            })}
        </Timeline>
    );
}
